export default [
  //Students
  {
    path: "/ChO7fec5a0b8d9815fed83c5b744250081d73f5079c6b49758621OpG",
    children: [
      {
        path: "/YNoXHyC6Ct",
        name: "bece26.students",
        meta: {
          title: "BECE 2026 students",
          authRequired: true,
          acc: ["y37800"],
        },
        component: () => import("@/views/bece/tws/student/index.vue"),
      },
      {
        path: "/YNoXfecb0a97cd2a4cad2a1f5f99HyC6C",
        name: "create.student.bece26",
        meta: {
          title: "Create BECE 2026 student",
          authRequired: true,
          acc: ["y31381"],
        },
        component: () => import("@/views/bece/tws/student/create.vue"),
      },
      {
        path: "/BtKNdNfe90040ffd64ab336e90f2af9Vg8/:str?",
        name: "bece26.student",
        meta: {
          title: "View BECE 2026 student",
          authRequired: true,
          acc: ["y79312"],
        },
        component: () => import("@/views/bece/tws/student/view.vue"),
      },
      {
        path: "/OnqQff980d939f753c8eb0f18227fkp/:str?",
        name: "bece26.studentedit",
        meta: {
          title: "Edit BECE 2026 student",
          authRequired: true,
          acc: ["y54446"],
        },
        component: () => import("@/views/bece/tws/student/edit.vue"),
      },
      {
        path: "/ziWxGJgu",
        name: "bece26.studentsanalysis",
        meta: {
          title: "BECE 2026 students analysis",
          authRequired: true,
          acc: ["y4861s33"],
        },
        component: () => import("@/views/bece/tws/student/analysis.vue"),
      },
      // {
      //   path: "/generate",
      //   name: "generateExamNumber",
      //   meta: {
      //     title: "GENERATE EXAM NUMBER",
      //   },
      //   component: () =>
      //     import("../views/bece/student_management/generateExamNumber.vue"),
      // },
      // {
      //   path: "/export",
      //   name: "exportStudents",
      //   meta: {
      //     title: "EXPORT STUDENTS",
      //   },
      //   component: () =>
      //     import("../views/bece/student_management/exportStudents.vue"),
      // },
    ],
  },
];
